import { useEffect, useRef, useState } from "react";
import { getOpenAI } from "../services/api";

const Input = ({
  title,
  forID,
  val,
  handleChange,
  extra = false,
  trans,
  orgVal,
  handleTitleGo,
  refresh,
}) => {
  const [local, setLocal] = useState(val);
  const inputRef = useRef(null);

  // console.log(title);

  useEffect(() => {
    async function startMe() {
      if (extra && val === "" && orgVal) {
        const input = inputRef.current;
        let response = null;
        if (trans === "English") {
          response = await getOpenAI(orgVal, trans, 1, 1);
        } else {
          response = await getOpenAI(orgVal, trans, 0, 1);
        }
        handleChange({ target: { id: input.id, value: response } });
        setLocal(response);
      } else setLocal(val);
    }
    startMe();
  }, [trans, val, extra, refresh]);

  function localChange(e) {
    setLocal(e.target.value);
    handleChange(e);
  }

  async function handleParaphrase(ref) {
    let text = local;
    let res = await getOpenAI(text, trans, 1, 1);
    const input = inputRef.current;
    setLocal(res);
    handleChange({ target: { id: input.id, value: res } });
  }

  return (
    <div className="customFlex">
      <div className="flex items-center w-full">
        <div className="labelDiv">
          <label htmlFor={forID}>{title}</label>
          {extra ? (
            <button
              className="block custombtn"
              type="button"
              onClick={() => handleParaphrase(inputRef)}
            >
              Paraphrase
            </button>
          ) : !extra && forID === "title" ? (
            <button
              className="block custombtn"
              type="button"
              onClick={() => handleTitleGo()}
            >
              Go
            </button>
          ) : null}
        </div>
        <div className="inputDiv">
          <input
            type="text"
            id={forID}
            ref={inputRef}
            name={forID}
            className="customInput"
            value={local}
            onChange={(e) => localChange(e)}
          />
        </div>
      </div>
    </div>
  );
};

export default Input;
